'use client';

import { useCallback, useEffect, useState } from 'react';

import { getSystemParameters, type SystemParameter } from '@/actions/getSystemParameters';

/**
 * @deprecated Use `useWhitelabelConfig` from `@/hooks/useWhitelabelConfig`
 * (or `loadWhitelabelConfig` em server components) com as chaves tipadas
 * de `@/types/enums/WhitelabelConfig`. SystemParameters é o sistema legado
 * e será removido em breve.
 */
export const useSystemParameters = () => {
  const [systemParameters, setSystemParameters] = useState<SystemParameter[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchParameters = async () => {
      try {
        setLoading(true);
        const response = await getSystemParameters();
        if (response?.data) {
          setSystemParameters(response.data);
        } else {
          setError('Nenhum parâmetro do sistema encontrado.');
        }
      } catch (err) {
        console.error('Falha ao buscar parâmetros do sistema:', err);
        setError('Falha ao carregar parâmetros do sistema.');
      } finally {
        setLoading(false);
      }
    };

    fetchParameters();
  }, []);

  const getParameterValue = useCallback(
    (key: string): string => {
      return systemParameters.find((param) => param.key === key)?.value ?? '';
    },
    [systemParameters],
  );

  return { systemParameters, loading, error, getParameterValue };
};
